import { render, staticRenderFns } from "./JsHero.vue?vue&type=template&id=dbee862c"
import script from "./JsHero.vue?vue&type=script&lang=js"
export * from "./JsHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports